import {format} from "date-fns";
import {IColumn} from '../../../components/ui/DataGrid';
import {IRankingReport} from '../../RankingReportCreationContainer/lib/interfaces';

export const openRankingReport = (id: number) => {
  const options = `width=${$(window).width()},height=${$(window).height()},scrollbars=1,resizable=1`
  const page = `/rankingReportView?report_id=${id}`

  window.open(page, '', options)
}

export const previewRankingReport = (id: number) => {
  const options = `width=${$(window).width()},height=${$(window).height()},scrollbars=1,resizable=1`
  const page = `/rankingReportView?report_id=${id}&deletePreview=true`

  window.open(page, '', options)
}

export const exportCSV = (exportData: any[], reportName) => {
  const csvContent = 'data:text/csv;charset=utf-8,' +
    exportData.map((e) => e.join(',')).join('\n');
  const encodedUri = encodeURI(csvContent)
  const link = document.createElement('a')
  const currentDate = new Date();// linea para obtener fecha y hora
  const formattedDate = format(currentDate, "yyyy-MM-dd'T'HH:mm:ss"); //linea para formateo

  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${reportName}-${formattedDate}`);
  document.body.appendChild(link); // Required for FF
  link.click();
}

export const sortOnlyValidRowsOnTop = (a, b, sortByProperty, order) => {
  if (order === 'asc') {
    const orderA = a[sortByProperty] === null ? 9999 : Number(a[sortByProperty]);
    const orderB = b[sortByProperty] === null ? 9999 : Number(b[sortByProperty]);
    if (orderA < orderB) {
      return -1;
    }
    if (orderA > orderB) {
      return 1;
    }
  } else {
    const orderA = a[sortByProperty] === null ? -9999 : Number(a[sortByProperty]);
    const orderB = b[sortByProperty] === null ? -9999 : Number(b[sortByProperty]);
    if (orderA < orderB) {
      return 1;
    }
    if (orderA > orderB) {
      return -1;
    }
  }
  return 0;
}
export const orderAsc = (a, b) => {
  const orderA = a.order;
  const orderB = b.order;
  if (orderA < orderB) {
    return -1;
  }
  if (orderA > orderB) {
    return 1;
  }
  return 0;
}

export function getRollupPositions(dataGridRecords: any[]) {
  const rollupRowsIdx = []
  for (let index = 0; index < dataGridRecords.length; index++) {
    if (dataGridRecords[index].isRollup) {
      rollupRowsIdx.push(index);
    }
  }
  return rollupRowsIdx
}
export function getIndustryAvgPosition(dataGridRecords: any[]) {
  const rollupRowsIdx = []
  for (let index = 0; index < dataGridRecords.length; index++) {
    if (dataGridRecords[index].isIndustryAvg) {
      rollupRowsIdx.push(index);
    }
  }
  return rollupRowsIdx
}

// @ts-ignore
export function getColumnNamesList(rankingReportColumns: IColumn[]) {
  return ['Hierarchy Record', 'Hierarchy Level', ...rankingReportColumns.reduce((acc, curr) => {
    return [...acc, curr.name];
  }, [])];
}
